import { Home, BookOpen, MessageCircle, Wrench, Menu } from "lucide-react";
import { useLocation, useNavigate } from "react-router";
import { cn } from "@reframe-mobile/lib/cn";

interface Tab {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  path: string;
  match: (pathname: string) => boolean;
}

const tabs: Tab[] = [
  {
    label: "홈",
    icon: Home,
    path: "/",
    match: (pathname) => pathname === "/" || pathname === "",
  },
  {
    label: "기록",
    icon: BookOpen,
    path: "/records",
    match: (pathname) => pathname.startsWith("/records"),
  },
  {
    label: "상담",
    icon: MessageCircle,
    path: "/chat",
    match: (pathname) => pathname.startsWith("/chat"),
  },
  {
    label: "도구",
    icon: Wrench,
    path: "/tools",
    match: (pathname) => pathname.startsWith("/tools"),
  },
  {
    label: "더보기",
    icon: Menu,
    path: "/more",
    match: (pathname) => pathname.startsWith("/more"),
  },
];

export function BottomTab() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-20 flex border-t border-border bg-background"
      style={{
        height: `calc(56px + var(--safe-area-inset-bottom))`,
        paddingBottom: "var(--safe-area-inset-bottom)",
      }}
    >
      {tabs.map((tab) => {
        const isActive = tab.match(location.pathname);
        const Icon = tab.icon;

        return (
          <button
            key={tab.label}
            type="button"
            className={cn(
              "flex flex-1 flex-col items-center justify-center gap-0.5 pt-1.5",
              isActive ? "text-primary" : "text-muted-foreground",
            )}
            onClick={() => navigate(tab.path)}
          >
            <Icon className="h-5 w-5" />
            <span className="text-[10px] font-medium">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
